<template>
  <div class="app-container">
    <div class="anjian-wrap">
      <div class="common-section-bg anjian-shaixuan">
        <div class="shaixuan-item">
          <el-input v-model="listQuery.key"
                    clearable
                    :placeholder="$t('user.username')" />
        </div>
        <div class="shaixuan-item">
          <el-select v-model="listQuery.section_id"
                     clearable
                     placeholder="请选择角色">
            <el-option v-for="item in positionList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id" />
          </el-select>
        </div>
        <div class="shaixuan-item">
          <!-- @keyup.enter.native="handleFilter" -->
          <el-button type="primary"
                     style="background: #1067e0; border-color: #1067e0"
                     icon="el-icon-search"
                     @click="handleFilter()">
            {{ $t("table.search") }}
          </el-button>
        </div>
        <div class="shaixuan-item">
          <el-button type="primary"
                     style="background: #1067e0; border-color: #1067e0"
                     icon="el-icon-plus"
                     @click="handleCreate">
            {{ $t("table.add") }}
          </el-button>
        </div>
      </div>
      <div class="common-section-bg common-section-top biaoge-data">
        <el-table :key="tableKey"
                  v-loading="listLoading"
                  :data="list"
                  fit
                  highlight-current-row
                  style="width: 100%"
                  @sort-change="sortChange">
          <el-table-column label="id"
                           prop="id"
                           align="center" />
          <el-table-column label="用户名"
                           prop="name"
                           align="center" />
          <el-table-column label="角色"
                           align="center"
                           prop="role_name" />
          <el-table-column label="电话"
                           prop="phone"
                           align="center">
          </el-table-column>
          <el-table-column label="状态"
                           prop="status"
                           align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status"
                         type="success"
                         size="mini"
                         plain>正常</el-button>
              <el-button v-else
                         type="danger"
                         size="mini"
                         plain>禁用</el-button>
            </template>
          </el-table-column>
          <el-table-column label="最后登录IP"
                           prop="lastip"
                           align="center" />
          <el-table-column label="最后登录时间"
                           prop="lasttime"
                           align="center" />
          <el-table-column label="操作"
                           align="center"
                           width="240"
                           class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button type="primary"
                         style="
                                        background: #1067e0;
                                        border-color: #1067e0;
                                    "
                         @click="handleUpdate(scope.row)">
                编辑
              </el-button>
              <el-button type="primary"
                         style="
                                        background: #ffba00;
                                        border-color: #ffba00;
                                    "
                         @click="handlePassword(scope.row)">
                密码
              </el-button>
              <el-button type="primary"
                         style="
                                        background: #ff4040;
                                        border-color: #ff4040;
                                    "
                         @click="handleDelete(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination v-show="total"
                    :total="total"
                    :page.sync="listQuery.page"
                    :limit.sync="listQuery.size"
                    @pagination="getList" />
      </div>
    </div>

    <!-- 用户 -->
    <el-drawer custom-class="custom-drawer"
               :visible.sync="dialogFormVisible"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ textMap }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="dialogFormVisible = false" />
        </div>
      </template>
      <div class="custom-content">
        <el-form ref="dataForm"
                 v-loading="dialogFormLoading"
                 :rules="rules"
                 :model="temp"
                 label-position="right"
                 :label-width="formLabelWidth">
          <el-form-item label="用户名"
                        prop="name">
            <el-input v-model="temp.name" />
          </el-form-item>
          <el-form-item label="手机号"
                        prop="phone"><el-input v-model="temp.phone" /> </el-form-item>
          <el-form-item v-if="dialogStatus === 'create'"
                        label="密码"
                        prop="password">
            <el-input ref="password"
                      v-model="temp.password"
                      :type="passwordType" />
            <span class="show-pwd"
                  @click="showPwd">
              <svg-icon :icon-class="
                passwordType === 'password'
                  ? 'eye'
                  : 'eye-open'
              " />
            </span>
            <span>*必须6-15位，且必须包含大小写字母、数字、特殊字符 ! @ # $ % & . _</span>
          </el-form-item>
          <el-form-item v-if="dialogStatus === 'create'"
                        label="二次确认密码"
                        prop="confirm_password">
            <el-input ref="password"
                      v-model="temp.confirm_password"
                      :type="passwordType" />
            <span class="show-pwd"
                  @click="showPwd">
              <svg-icon :icon-class="
                passwordType === 'password'
                  ? 'eye'
                  : 'eye-open'
              " />
            </span>
          </el-form-item>
          <!-- <el-form-item label="电话"
                        prop="phone">
            <el-input v-model="temp.phone" />
          </el-form-item> -->
          <el-form-item label="角色"
                        prop="role_ids">
            <el-select v-model="temp.role_ids"
                       placeholder="请选择角色"
                       multiple>
              <el-option v-for="(item, index) in positionList"
                         :key="item.id || index"
                         :label="item.name"
                         :value="Number(item.id)" />
            </el-select>
          </el-form-item>
           <el-form-item label="小区"
                        prop="community_id">
            <el-select v-model="temp.community_id"
                       filterable
                       clearable
                       placeholder="请选择小区">
              <el-option v-for="(item,index) in commList"
                         :key="item.id"
                         :label="item.commName"
                         :value="Number(item.id)" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="temp.status"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="1"
                       :inactive-value="0" />
          </el-form-item>
        </el-form>
        <div class="fix-fotter">
          <div class="default-btn pointer"
               @click="
            dialogStatus === 'create'
              ? createData()
              : updateData()
          ">
            {{ $t("table.confirm") }}
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 角色 -->
    <el-drawer custom-class="custom-drawer"
               :visible.sync="roleDialogFormVisible"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ $t("user.role") }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="roleDialogFormVisible = false" />
        </div>
      </template>
      <div class="custom-content pdl30">
        <div v-loading="roleDialogFormLoading">
          <el-checkbox v-model="checkAll"
                       :indeterminate="isIndeterminate"
                       @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="roleData.role_ids"
                             @change="handleCheckedCitiesChange">
            <el-checkbox v-for="item in roles"
                         :key="item.id"
                         :label="item.id"
                         style="margin-top: 15px">{{ item.name
            }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="!roleDialogFormLoading"
             class="fix-fotter">
          <div class="default-btn pointer"
               @click="setRole()">
            {{ $t("table.confirm") }}
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 改密码 -->
    <el-drawer custom-class="custom-drawer"
               :visible.sync="passwordDialogFormVisible"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ $t("user.password") }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="passwordDialogFormVisible = false" />
        </div>
      </template>
      <div class="custom-content">
        <el-form ref="dataForm2"
                 v-loading="pwdDialogFormLoading"
                 :rules="passwordRules"
                 :model="passwordData"
                 label-position="right"
                 :label-width="formLabelWidth">
          <el-form-item label="新密码"
                        prop="password">
            <el-input ref="password2"
                      v-model="passwordData.password"
                      :type="passwordType2" />
            <span class="show-pwd"
                  @click="showPwd2">
              <svg-icon :icon-class="
                passwordType2 === 'password'
                  ? 'eye'
                  : 'eye-open'
              " />
            </span>
            <span>*必须6-15位，且必须包含大小写字母、数字、特殊字符 ! @ # $ % & . _</span>
          </el-form-item>
          <el-form-item :label="$t('login.confirmPassword')"
                        prop="confirm_password">
            <el-input ref="confirmPassword2"
                      v-model="passwordData.confirm_password"
                      :type="confirmPasswordType2" />
            <span class="show-pwd"
                  @click="showConfirmPwd2">
              <svg-icon :icon-class="
                confirmPasswordType2 === 'password'
                  ? 'eye'
                  : 'eye-open'
              " />
            </span>
          </el-form-item>
        </el-form>
        <div class="fix-fotter">
          <div class="default-btn pointer"
               @click="savePwd">
            {{ $t("table.confirm") }}
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Role from '@/api/role'
import Department from '@/api/console/Department'
import Qu from '@/api/tianzheng/Qu'
import uploadFile from '@/components/UploadExcel/file'
import md5 from 'js-md5'

import {
  fetchList,
  fetchDetail,
  create,
  update,
  del,
  role,
  password,
  updrole
} from '@/api/user'
import { fetchList as fetchRoleList } from '@/api/role'
import waves from '@/directive/waves' // Waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination

export default {
  name: 'UserIndex',
  components: {
    Pagination,
    uploadFile
  },
  directives: {
    waves
  },
  data () {
    var validateUsername = (rule, value, callback) => {
      if (value === undefined || value === '') {
        callback(new Error(this.$t('user.usernameRequired')))
      } else {
        callback()
      }
    }
    const pwdCheck = (rule, value, callback) => {
      const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]
      const englishAlphabet = ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f',
        'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm']
      const specialCharacters = ['!', '@', '#', '$', '%', '&', '.', '_']
      let isNumber = false
      let isEnglishAlphabet = false
      let isBigEnglishAlphabet = false
      let isSpecialCharacters = false
      numbers.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isNumber = true
        }
      })
      englishAlphabet.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isEnglishAlphabet = true
        }
        if (value.indexOf(item.toUpperCase()) !== -1) {
          isBigEnglishAlphabet = true
        }
      })
      specialCharacters.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isSpecialCharacters = true
        }
      })
      if (isNumber && isEnglishAlphabet && isBigEnglishAlphabet && isSpecialCharacters) {
        callback()
      } else {
        callback(new Error('密码格式错误'))
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (value === undefined || value === '') {
        callback(new Error(this.$t('user.phone')))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (value === undefined || value === '') {
        callback(new Error(this.$t('login.pleaseEnterPassword')))
      } else if (value.length < 6) {
        callback(new Error(this.$t('login.pleaseEnterPassword')))
      } else {
        callback()
      }
    }
    var validateConfirmPassword = (rule, value, callback) => {
      if (value === undefined || value === '') {
        callback(new Error(this.$t('login.pleaseEnterPassword')))
      } else if (value !== this.temp.password) {
        callback(new Error(this.$t('user.confirmPasswordError')))
      } else {
        callback()
      }
    }
    var validateRealname = (rule, value, callback) => {
      if (value === undefined || value === '') {
        callback(new Error(this.$t('user.realnameRequired')))
      } else {
        callback()
      }
    }
    var validateConfirmPassword2 = (rule, value, callback) => {
      if (value === undefined || value === '') {
        callback(new Error(this.$t('login.pleaseEnterPassword')))
      } else if (value !== this.passwordData.password) {
        callback(new Error(this.$t('user.confirmPasswordError')))
      } else {
        callback()
      }
    }
    return {
      positionList: [],
      bumenList: [],
      showImportModalStatus: false,
      tableKey: 0,
      list: [],
      area_list: [],
      total: 0,
      listLoading: false,
      xianList: [],
      xiangList: [],
      cunList: [],
      listQuery: {
        page: 1,
        size: 10,
        key: null
      },
      temp: {
        id: undefined,
        role_ids: [],
        username: '',
        realname: '',
        email: '',
        password: '',
        confirm_password: '',
        phone: '',
        status: 1,
        community_id:''
      },
      commList:[],
      dialogFormVisible: false,
      dialogStatus: '',
      rules: {
        name: [
          {
            required: true,
            validator: validateUsername,
            trigger: 'blur'
          }
        ],
        // phone: [
        //   {
        //     required: true,
        //     validator: validatePhone,
        //     trigger: "blur",
        //   },
        // ],
        confirm_password: [
          {
            required: true,
            validator: validateConfirmPassword,
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '密码必须填写', trigger: 'blur' },
          {
            type: 'string',
            min: 6,
            max: 15,
            message: '密码 6 - 15 位长度',
            trigger: 'blur'
          },
          { validator: pwdCheck, trigger: 'blur' }
        ],
        role_ids: [
          {
            required: true,
            message: '角色必须填写',
            trigger: 'change'
          }
        ]
      },
      passwordRules: {
        password: [
          { required: true, message: '密码必须填写', trigger: 'blur' },
          {
            type: 'string',
            min: 6,
            max: 15,
            message: '密码 6 - 15 位长度',
            trigger: 'blur'
          },
          { validator: pwdCheck, trigger: 'blur' }
        ],
        confirm_password: [
          {
            required: true,
            validator: validateConfirmPassword2,
            trigger: 'blur'
          }
        ]
      },
      dialogFormLoading: false,
      passwordType: 'password',
      confirmPasswordType: 'password',
      passwordType2: 'password',
      confirmPasswordType2: 'password',
      roles: [],
      roleDialogFormVisible: false,
      roleDialogFormLoading: false,
      roleData: {
        id: undefined,
        role_ids: []
      },
      isIndeterminate: false,
      checkAll: false,
      passwordDialogFormVisible: false,
      passwordData: {
        id: undefined,
        password: '',
        confirm_password: ''
      },
      pwdDialogFormLoading: false
    }
  },
  computed: {
    formLabelWidth: function () {
      return this.$store.getters.language === 'zh' ? '140px' : '200px'
    },
    textMap: function () {
      return this.dialogStatus === 'update'
        ? this.$t('form.edit')
        : this.$t('form.create')
    }
  },
  created () {
    this.getList()
    this.getPosition()
  },
  methods: {
    /**
     * @name: 角色列表
     * @return {*}
     * @desc:
     */
    getPosition () {
      Role.select({}).then((res) => {
        if (res.code == 200) {
          this.positionList = res.result
        }
      })
    },
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    showConfirmPwd () {
      if (this.confirmPasswordType === 'password') {
        this.confirmPasswordType = ''
      } else {
        this.confirmPasswordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.confirmPassword.focus()
      })
    },
    showPwd2 () {
      if (this.passwordType2 === 'password') {
        this.passwordType2 = ''
      } else {
        this.passwordType2 = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    showConfirmPwd2 () {
      if (this.confirmPasswordType2 === 'password') {
        this.confirmPasswordType2 = ''
      } else {
        this.confirmPasswordType2 = 'password'
      }
      this.$nextTick(() => {
        this.$refs.confirmPassword.focus()
      })
    },
    getList () {
      this.listLoading = true
      fetchList(this.listQuery).then((response) => {
        this.list = response.result.list
        this.total = response.result.total
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange (data) {
      const { prop, order } = data
      if (prop === 'id') {
        this.sortByID(order)
      }
    },
    sortByID (order) {
      if (order === 'ascending') {
        this.listQuery.id_sort = 'asc'
      } else {
        this.listQuery.id_sort = 'desc'
      }
      this.handleFilter()
    },
    resetTemp () {
      this.temp = {
        id: undefined,
        role_ids: [],
        username: '',
        realname: '',
        email: '',
        password: '',
        confirm_password: '',
        phone: '',
        status: 1,
        community_id:''
      }
    },
    handleCreate () {
      this.getXianList()
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * @name: 创建用户
     * @return {*}
     * @desc:
     */
    createData () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            name: this.temp.name,
            realname: this.temp.name,
            email: this.temp.email,
            phone: this.temp.phone,
            password: this.temp.password,
            confirm_password: this.temp.confirm_password,
            role_ids: this.temp.role_ids,
            status: this.temp.status,
            community_id: this.temp.community_id,
          }
          create(params).then((res) => {
            if (res.code == 200) {
              this.dialogFormVisible = false
              this.$message.success(
                this.$t('form.createSuccess')
              )
              this.handleFilter()
            }
          })
        }
      })
    },
    /**
     * @name: 查询用户
     * @param {*} row
     * @return {*}
     * @desc:
     */
    async handleUpdate (row) {
      this.dialogFormLoading = true
      this.resetTemp()
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.currentId = row.id
      try {
        await this.getXianList()
        const res = await fetchDetail({ admin_id: row.id })
        const communityId = res.result.community_id
        this.temp = {
          name: res.result.realname,
          email: res.result.email,
          phone: res.result.phone,
          status: res.result.status,
          // el-select 严格匹配类型，统一转成 number，避免回显成原始 id
          role_ids: (res.result.role_ids || []).map(id => Number(id)),
          community_id: communityId === null || communityId === undefined || communityId === ''
            ? ''
            : Number(communityId)
        }
      } finally {
        this.dialogFormLoading = false
      }
    },
    /**
     * @name: 编辑用户
     * @return {*}
     * @desc:
     */
    updateData () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            admin_id: this.currentId,
            name: this.temp.name,
            realname: this.temp.name,
            phone: this.temp.phone,
            email: this.temp.email,
            role_ids: this.temp.role_ids,
            status: this.temp.status,
            community_id: this.temp.community_id,
          }
          update(params).then((res) => {
            if (res.code == 200) {
              this.dialogFormVisible = false
              this.$message.success(
                this.$t('form.createSuccess')
              )
              this.handleFilter()
            }
          })
        }
      })
    },
    /**
     * @name: 删除用户
     * @param {*} row
     * @return {*}
     * @desc:
     */
    handleDelete (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          del({
            admin_id: row.id
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('form.delSuccess'))
              this.handleFilter()
            }
          })
        })
        .catch(() => { })
    },
    /**
     * @name: 查角色
     * @param {*} row
     * @return {*}
     * @desc:
     */
    handleRole (row) {
      this.roleData = {
        id: undefined,
        role_ids: []
      }
      this.isIndeterminate = false
      this.checkAll = false

      this.roleData.id = row.id
      this.roleDialogFormLoading = true
      this.roleDialogFormVisible = true
      fetchRoleList({
        admin_id: row.id
      }).then((res) => {
        this.roles = res.result.list
        this.roleData.role_ids = res.result.user_role_ids
        this.handleCheckedCitiesChange(this.roleData.role_ids)
        this.roleDialogFormLoading = false
      })
    },
    querySearchSheng (query) {
      this.getXianList(query)
    },
    /**
     * @name: 查询密码
     * @param {*} row
     * @return {*}
     * @desc:
     */
    handlePassword (row) {
      this.currentId = row.id
      this.passwordData.password = ''
      this.passwordData.confirm_password = ''
      this.passwordDialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm2'].clearValidate()
      })
    },
    /**
     * @name: 更新角色
     * @return {*}
     * @desc:
     */
    setRole () {
      const params = {
        admin_id: this.roleData.id,
        role_ids: this.roleData.role_ids.join(',')
      }
      updrole(params).then((res) => {
        this.roleDialogFormVisible = false
        if (res.code == 200) {
          this.$message.success(this.$t('form.updateSuccess'))
        }
      })
    },
    handleCheckAllChange (val) {
      var roleIds = []
      if (val) {
        this.roles.forEach((item) => {
          roleIds.push(item.id)
        })
      }
      this.roleData.role_ids = roleIds
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.roles.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.roles.length
    },
    getXianList () {
      return Qu.select({}).then(res => {
        if (res.code == 200) {
          this.commList = res.result || []
        }
      })
    },
    /**
     * @name: 修改密码
     * @return {*}
     * @desc:
     */
    savePwd () {
      this.$refs['dataForm2'].validate((valid) => {
        if (valid) {
          const params = {
            admin_id: this.currentId,
            password: this.passwordData.password,
            confirm_password: this.passwordData.confirm_password
          }
          password(params).then(() => {
            this.passwordDialogFormVisible = false
            this.$message.success(this.$t('form.updateSuccess'))
            this.handleFilter()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.show-pwd {
  position: absolute;
  right: 10px;
  top: 3px;
  font-size: 16px;
  /*color: $dark_gray;*/
  cursor: pointer;
  user-select: none;
}
</style>
